import { render, staticRenderFns } from "./auto.vue?vue&type=template&id=3e8a9f4b&scoped=true&"
import script from "./auto.vue?vue&type=script&lang=js&"
export * from "./auto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8a9f4b",
  null
  
)

export default component.exports